import { useRoutes } from 'react-router-dom'
import { useContext } from 'react'
import AuthContext from 'context/AuthContext'
// routes
import MainRoutes from './MainRoutes'
import AdminRoutes from './AdminRoutes'
import HRRoutes from './HRRoutes'
import AccountantRoutes from './AccountantRoutes'

export default function CombineRoutes () {
  let { user } = useContext(AuthContext)

  const checkRoles = {
    admin: AdminRoutes,
    subadmin: AdminRoutes,
    HRAdmin: HRRoutes,
    AccountantAdmin: AccountantRoutes
  }
  const token = typeof window !== "undefined" ? localStorage.getItem("token") : null
  return useRoutes(
    [user && token ? checkRoles[user?.role] || MainRoutes : MainRoutes],
    process.env.BASENAME
  )
}
